<script>
import {Line} from 'vue-chartjs'
import {trans} from "../../../app";
import {getColor} from "../../../utils/colors";

export default {
    extends: Line,
    methods: {
        setOrdersData(ordersData) {
            this.ordersData = ordersData;
            this.renderChart({
                labels: this.labels,
                datasets: this.datasets,
            }, this.options);
        }
    },
    data: () => ({
        ordersData: [],
        options: {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true,
                    }
                }]
            },
            elements: {
                line: {
                    fill: false
                }
            },
        }
    }),
    computed: {
        datasets() {
            let datasets = [
                {
                    label: trans('app.statistics.orders.paid_orders'),
                    data: this.ordersData.map((row) => {
                        return row.paid_orders;
                    }),
                },
                {
                    label: trans('app.statistics.premium_30_days'),
                    data: this.ordersData.map((row) => {
                        return row.premium_30_days;
                    }),
                },
                {
                    label: trans('app.statistics.premium_180_days'),
                    data: this.ordersData.map((row) => {
                        return row.premium_180_days;
                    }),
                },
                {
                    label: trans('app.statistics.premium_365_days'),
                    data: this.ordersData.map((row) => {
                        return row.premium_365_days;
                    }),
                },
                {
                    label: trans('app.statistics.standard_30_days'),
                    data: this.ordersData.map((row) => {
                        return row.standard_30_days;
                    }),
                },
                {
                    label: trans('app.statistics.standard_180_days'),
                    data: this.ordersData.map((row) => {
                        return row.standard_180_days;
                    }),
                },
                {
                    label: trans('app.statistics.standard_365_days'),
                    data: this.ordersData.map((row) => {
                        return row.standard_365_days;
                    }),
                },
                {
                    label: trans('app.statistics.student_30_days'),
                    data: this.ordersData.map((row) => {
                        return row.student_30_days;
                    }),
                },
                {
                    label: trans('app.statistics.student_180_days'),
                    data: this.ordersData.map((row) => {
                        return row.student_180_days;
                    }),
                },
                {
                    label: trans('app.statistics.student_365_days'),
                    data: this.ordersData.map((row) => {
                        return row.student_365_days;
                    }),
                },
            ];
            datasets = datasets.map((dataset, index) => {
                dataset.borderColor = getColor(index)
                return dataset;
            })
            return datasets;
        },
        labels() {
            return this.ordersData.map((row) => {
                return row.date
            });
        }
    },
    mounted() {
        this.renderChart({
            labels: this.labels,
            datasets: this.datasets
        }, this.options)
    }
}
</script>